import { IConfigState } from '../../types/redux/config';
import { TReduxActions } from '../../types/redux';
import { EPromoSnippetActions } from '../../actions/promoSnippet';

export const defaultState: IConfigState = {
  isPromoSnippetEnabled: true,
  isPromoSnippetDisplayed: false,
  isDiscountMortgageEnabled: false,
  isDiscountMortgageBannerEnabled: false,
  isBrokerConsultantBannerEnabled: false,
  brokerConsultantBannerButtonText: null,
  // TODO: Удалить в CD-251393.
  isBrokerFlightEnabled: false,
};

export const configReducer = (state: IConfigState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EPromoSnippetActions.setPromoSnippetVisibility:
      return {
        ...state,
        isPromoSnippetDisplayed: action.payload,
      };
    default:
      return state;
  }
};
